import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AssetListLayer from "../components/AssetListLayer";

const AssetListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Asset List" />

        {/* AssetListLayer */}
        <AssetListLayer />
      </MasterLayout>
    </>
  );
};

export default AssetListPage; 
